/* @flow */
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import Input from 'components/Input.jsx';
import focusNode from 'utils/focusNode';

import './styles/PrependedTextInput.scss';

class PrependedTextInput extends React.Component {
  static propTypes = {
    prepend: React.PropTypes.string,
  };

  getInputNode = () => {
    return ReactDOM.findDOMNode(this.refs.input);
  };

  getValue = () => {
    return this.getInputNode().value;
  };

  handleFocus = () => {
    focusNode(ReactDOM.findDOMNode(this.refs.input));
  };

  render() {
    return (
      <div className="PrependedTextInput" onFocus={this.handleFocus}>
        <span className="PrependedTextInput-prepend">{this.props.prepend}</span>
        <Input
          {...this.props}
          ref="input"
          className={cx('PrependedTextInput-input', this.props.className)}
          type="text"
        />
      </div>
    );
  }
}

export default PrependedTextInput;



// WEBPACK FOOTER //
// ./src/components/PrependedTextInput.jsx